"use client";

// Browser-chrome frame that scales a full 1440px-wide app render down to fit the hero
// column — same ResizeObserver approach as the design's landing.jsx BrowserMock.
import { useEffect, useRef, useState } from "react";

const BASE_W = 1440;
const BASE_H = 980;

export function BrowserMock({ children }: { children: React.ReactNode }) {
	const ref = useRef<HTMLDivElement>(null);
	const [scale, setScale] = useState(0.39);

	useEffect(() => {
		const el = ref.current;
		if (!el) return;
		const fit = () => setScale(el.clientWidth / BASE_W);
		fit();
		const ro = new ResizeObserver(fit);
		ro.observe(el);
		return () => ro.disconnect();
	}, []);

	return (
		<div className="browser-mock">
			<div className="browser-bar">
				<span className="tl" style={{ background: "#e07a5a" }} />
				<span className="tl" style={{ background: "#e6c25a" }} />
				<span className="tl" style={{ background: "#7faa6e" }} />
				<div className="browser-url">app.useaspen.com</div>
			</div>
			<div ref={ref} className="browser-viewport" style={{ height: BASE_H * scale }}>
				<div style={{ width: BASE_W, height: BASE_H, transform: `scale(${scale})`, transformOrigin: "top left", pointerEvents: "none" }}>
					{children}
				</div>
			</div>
		</div>
	);
}
